import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';

import {
  PERMISSAO_TELA_CLIENTES_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuTelevendas = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Televendas"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_CLIENTES_LISTAR] && hasResource('clientes')}
    {permissoes[PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR] &&
      hasResource('categorias_cliente')}
  </SubMenu>
);

export default SubMenuTelevendas;
